var chunkMapping = {
	"759": [
		80759
	],
	"941": [
		16158,
		31226,
		59793
	],
	"994": [
		80994
	],
	"1099": [
		11099
	],
	"1180": [
		31180
	],
	"1525": [
		31525
	],
	"1535": [
		61535
	],
	"1537": [
		81537
	],
	"1573": [
		11573
	],
	"1664": [
		1664
	],
	"1961": [
		11961
	],
	"2303": [
		92303
	],
	"2326": [
		22326
	],
	"2379": [
		72379
	],
	"2429": [
		52429
	],
	"2585": [
		2585
	],
	"2911": [
		32911
	],
	"2984": [
		32984
	],
	"3312": [
		3312
	],
	"3789": [
		41026
	],
	"3994": [
		13994
	],
	"4154": [
		2202
	],
	"4863": [
		24863
	],
	"5147": [
		95147
	],
	"5309": [
		65309
	],
	"5783": [
		45783
	],
	"6068": [
		16068
	],
	"6147": [
		6147
	],
	"6614": [
		96614
	],
	"6711": [
		6711
	],
	"7011": [
		97011
	],
	"7662": [
		97662
	],
	"7702": [
		74241,
		54715,
		4004
	],
	"7740": [
		17740
	],
	"7923": [
		27923
	],
	"8199": [
		48199
	],
	"8581": [
		78581
	],
	"8680": [
		38680
	],
	"9117": [
		9117
	],
	"9282": [
		99282
	],
	"9533": [
		69533
	],
	"9803": [
		69803
	],
	"9846": [
		99846
	],
	"9853": [
		79853
	]
};
var idToExternalAndNameMapping = {
	"1664": [
		"default",
		"./ImagesCarousel",
		99287
	],
	"2202": [
		"default",
		"./TruncatedTextByWidth",
		99287
	],
	"2585": [
		"default",
		"./Checkbox",
		99287
	],
	"3312": [
		"default",
		"./TimePickers",
		99287
	],
	"4004": [
		"default",
		"./Toast",
		99287
	],
	"6147": [
		"default",
		"./CustomFields",
		99287
	],
	"6711": [
		"default",
		"./I18nService",
		99287
	],
	"9117": [
		"default",
		"./DefaultSearchBar",
		99287
	],
	"11099": [
		"default",
		"./DatePickerField",
		99287
	],
	"11573": [
		"default",
		"./ButtonDropdown",
		99287
	],
	"11961": [
		"default",
		"./PageDescription",
		99287
	],
	"13994": [
		"default",
		"./Footer",
		99287
	],
	"16068": [
		"default",
		"./ConfirmTrackingModal",
		99287
	],
	"16158": [
		"default",
		"./CreateOrder",
		11866
	],
	"17740": [
		"default",
		"./DefaultTextbox",
		99287
	],
	"22326": [
		"default",
		"./SearchBar",
		99287
	],
	"24863": [
		"default",
		"./ModalKebab",
		99287
	],
	"27923": [
		"default",
		"./Skeleton",
		99287
	],
	"31180": [
		"default",
		"./FormAttributeItem",
		99287
	],
	"31226": [
		"default",
		"./PriceItemsHelper",
		87642
	],
	"31525": [
		"default",
		"./FooterActions",
		99287
	],
	"32911": [
		"default",
		"./StatusTags",
		99287
	],
	"32984": [
		"default",
		"./QshipMap",
		99287
	],
	"38680": [
		"default",
		"./TablePaginationFullPage",
		99287
	],
	"41026": [
		"default",
		"./ReturnOrder",
		11866
	],
	"45783": [
		"default",
		"./DateRangePickerField",
		99287
	],
	"48199": [
		"default",
		"./ModalStatus",
		99287
	],
	"52429": [
		"default",
		"./MultiSelectDropdown",
		99287
	],
	"54715": [
		"default",
		"./Theme",
		99287
	],
	"59793": [
		"default",
		"./PopConfirm",
		99287
	],
	"61535": [
		"default",
		"./PudoDetails",
		99287
	],
	"65309": [
		"default",
		"./EmptyState",
		99287
	],
	"69533": [
		"default",
		"./TrackListing",
		99287
	],
	"69803": [
		"default",
		"./NavigationHorizontalBar",
		99287
	],
	"72379": [
		"default",
		"./ShipmentTrackIDSearchBar",
		99287
	],
	"74241": [
		"default",
		"./Button",
		99287
	],
	"78581": [
		"default",
		"./RadioGroupWithBox",
		99287
	],
	"79853": [
		"default",
		"./Text",
		99287
	],
	"80759": [
		"default",
		"./Tooltip",
		99287
	],
	"80994": [
		"default",
		"./PaginationQship",
		99287
	],
	"81537": [
		"default",
		"./PricingSummary",
		11866
	],
	"92303": [
		"default",
		"./ShipmentTrackIDSearchBarMobile",
		99287
	],
	"95147": [
		"default",
		"./SingleDropdownAndMulti",
		99287
	],
	"96614": [
		"default",
		"./Empty",
		99287
	],
	"97011": [
		"default",
		"./TabsBar",
		99287
	],
	"97662": [
		"default",
		"./QshipDetailMap",
		99287
	],
	"99282": [
		"default",
		"./Typography",
		99287
	],
	"99846": [
		"default",
		"./HistoryListing",
		99287
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}